import {  postAddNominee } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const add_NomineeThunk = createAsyncThunk(
  "add_NomineeThunk",
  async ({ body, token }) => {
    try {
      const response = postAddNominee(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
